/**
 * Tiny guarded wrapper over the Vibration API. A short buzz confirms an action on phones
 * that support it (Android Chrome); a no-op everywhere else (iOS Safari, desktop) — never
 * throws. Kept dependency-free so both UI and game code can call it.
 *
 * Pass a single duration for one buzz, or a pattern array (`[buzz, pause, buzz, …]`, in ms)
 * for multiple buzzes — e.g. `haptic([50, 80, 50, 80, 50])` is three short buzzes.
 */
export function haptic(pattern: number | number[] = 25): void {
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* vibration unsupported or blocked — ignore */
  }
}
